import * as React from "react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as moment from "moment";

import pageStyles from "./DetailPostStyles";
import HeaderImage from "assets/images/header_profile_videos.png";
import ProfilePlaceholder from "assets/icons/profile_placeholder.svg";
import { ElementsParallax, AdsComponent } from "components";
import { useBlog } from "services";
import Model from "hooks/Model";
import { PostProps } from "models";

function DetailPostScreen() {
  const styles = pageStyles();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const idPost = searchParams.get("id");

  const { loading, currentPosts } = useBlog();
  const currentPost: PostProps = React.useMemo(() => {
    return (
      currentPosts.find((data) => data.id === searchParams.get("id")) || {
        author: { name: "", image: "" },
      }
    );
  }, [currentPosts, searchParams]);

  const renderDOMComponents = (htmlString: string) => {
    document.getElementById("parsedContent").innerHTML = htmlString;
  };

  useEffect(() => {
    Model.setData("loading", false);
    Model.setData("layoutConfig", { withBg: true });

    if (!loading && !idPost) {
      navigate("/");
    }

    renderDOMComponents(currentPost.content);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, currentPost]);

  return (
    <>
      <ElementsParallax variant="leftBg" />
      <ElementsParallax variant="rightBg" />

      <div
        className={styles.bannerContainer}
        style={{
          backgroundImage: `url(${currentPost?.image || HeaderImage})`,
        }}
      >
        <div className={styles.blurBanner} />
        <h1 className={styles.title}>{currentPost.title}</h1>
        <div className={styles.containerProfileImage}>
          <img
            alt="profile"
            className={styles.profileImage}
            src={currentPost.author?.image || ProfilePlaceholder}
          />
          <p className={styles.nameProfile}>
            {currentPost.author.name},{" "}
            <span>
              {moment(currentPost.created, "x").format("DD MMM YYYY hh:mma")}
            </span>
          </p>
        </div>
      </div>

      <AdsComponent />

      <div id="parsedContent" className={styles.parsedContent} />
    </>
  );
}

export default DetailPostScreen;
